import { render, staticRenderFns } from "./new-data-table.vue?vue&type=template&id=7acb4298&scoped=true&"
import script from "./new-data-table.vue?vue&type=script&lang=js&"
export * from "./new-data-table.vue?vue&type=script&lang=js&"
import style0 from "./new-data-table.vue?vue&type=style&index=0&id=7acb4298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acb4298",
  null
  
)

export default component.exports